import { toggleAdDisclosure } from "../../bladejs/toggle-ad-disclosure";

// Advertiser Disclosure Toggle
toggleAdDisclosure({
	button: "#hero__advertiser-disclosure--button",
	content: "#hero__advertiser-disclosure--content",
	closeButton: "#hero__advertiser-disclosure--content-close-button",
});
